var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SingleLoanMemberShortDetails.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-254864e7!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SingleLoanMemberShortDetails.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/components/SingleLoanMemberShortDetails.vue
// module id = 258
// module chunks = 0